import * as Sentry from '@sentry/react'

// Re-export Sentry for use in components
export { Sentry }

let initialized = false

export function initSentry() {
  if (typeof window === 'undefined') return
  if (initialized) return

  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (!dsn) {
    console.warn(
      '[Sentry] VITE_SENTRY_DSN not configured, skipping initialization',
    )
    return
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,

    // Tunnel through our own domain to bypass ad-blockers
    tunnel: '/api/sentry-tunnel',

    // Free tier optimizations
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  })

  initialized = true
}
